import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiDeleteArticleResponseBody } from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';
import { articleQueryKeyFactory } from './useArticleQuery';
import { articlesQueryKeyFactory } from './useArticlesQuery';

export type IUseDeleteArticleMutationValues = {
  appId: string;
  articleId: string;
};

export const useDeleteArticleMutation = (): UseMutationResult<
  IApiDeleteArticleResponseBody,
  unknown,
  IUseDeleteArticleMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseDeleteArticleMutationValues) =>
      api.articles.delete(values.appId, values.articleId),
    onSuccess: async (_, values) => {
      [
        // TODO once the API is updated to return the deleted resources
        // data.deletedResources.articleIds
        values.articleId,
      ]
        .map((articleId) => [
          {
            queryKey: articleQueryKeyFactory({
              appId: values.appId,
              articleId,
            }),
          },
        ])
        .flat()
        .forEach((filters) => queryClient.removeQueries(filters));

      await queryClient.invalidateQueries({
        queryKey: articlesQueryKeyFactory({
          appId: values.appId,
          // TODO: invalidate only categories that contained the deleted
          // article.
        }),
      });
    },
  });
};
